import RefreshButton from '@/components/Buttons/RefreshButton';
import LoadingBackdrop from '@/components/Grid/LoadingBackdrop';
import { GridToolbarContainer, GridToolbarProps } from '@mui/x-data-grid-pro';

interface IProps extends GridToolbarProps {
  loading: boolean;
  title: string;
  onRefresh: () => void;
}

const GridToolBar = ({ loading, title, onRefresh }: IProps) => {
  return (
    <GridToolbarContainer sx={{ padding: 0 }}>
      <div className='py-[24px] px-[30px] flex items-center justify-between relative w-full'>
        <span className='text-[20px] font-semibold'>{title}</span>
        <RefreshButton onClick={onRefresh} />
      </div>
      {loading ? <LoadingBackdrop /> : null}
    </GridToolbarContainer>
  );
};

export default GridToolBar;
